export function filterIdsBySubjectType<T extends Record<string, any>>(searchParams: T, subjectType: string): T {
  const idMap: Record<string, string> = {
    ['bank-account']: 'bankAccountId',
    contact: 'contactId',
    license: 'licenseId'
  }

  if (searchParams.subjectType) {
    const filtered = { ...searchParams }

    for (const key in idMap) {
      if (key !== subjectType) {
        delete filtered[idMap[key]]
      }
    }

    return filtered
  }

  return searchParams
}
